import { render, staticRenderFns } from "./ResellerProductListTable.vue?vue&type=template&id=2f07e3fc"
import script from "./ResellerProductListTable.vue?vue&type=script&lang=js"
export * from "./ResellerProductListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports